var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{staticClass:"chart bg-white",staticStyle:{"height":"400px","width":"1300px"},attrs:{"option":_vm.lineAndBar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }